import {
  ChangeDetectionStrategy,
  Component,
  contentChild,
  effect,
  ElementRef,
  inject,
  input,
  Renderer2,
  RendererStyleFlags2,
  viewChild,
} from '@angular/core';

import { InputDirective } from '../input/input.directive';

@Component({
  selector: 'sb-input-group',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './input-group.component.html',
  host: {
    class: 'relative flex',
  },
})
export class InputGroupComponent {
  postfix = input<string>();

  postfixEl = viewChild<ElementRef<HTMLSpanElement>>('postfixElement');
  inputEl = contentChild(InputDirective, { descendants: true, read: ElementRef<HTMLInputElement> });
  renderer = inject(Renderer2);

  constructor() {
    effect(() => {
      const offset = this.postfixEl()?.nativeElement.offsetWidth;
      const inputElement: HTMLInputElement = this.inputEl()?.nativeElement;
      if (!inputElement) {
        return;
      }
      // for now we need to use RendererStyleFlags2.Important to override tailwind styles that are currently all set to important
      if (offset) {
        this.renderer.setStyle(inputElement, 'padding-right', `${offset}px`, RendererStyleFlags2.Important);
      } else {
        this.renderer.removeStyle(inputElement, 'padding-right');
      }
    });
  }
}
